import React from 'react';
import { DecisionTreeQuestion } from '../../../../types';
import { QuestionStyle } from '../../../../styles/common';
import { SplitLayout, ContextCard, PanelCard } from '../SplitPanelLayout/styles';
import { ClientBubble } from '../ClientBubble';
import { AnswerOptions } from '../AnswerOptions';

interface MultiplePhaseViewProps {
  question: DecisionTreeQuestion;
  currentStep: any;
  selectedOption: number | null;
  onOptionClick: (optionId: number) => void;
  isReviewMode?: boolean;
}

export const MultiplePhaseView: React.FC<MultiplePhaseViewProps> = ({
  question,
  currentStep,
  selectedOption,
  onOptionClick,
  isReviewMode = false,
}) => {
  if (!currentStep) return null;

  return (
    <SplitLayout>
      <ContextCard>
        <QuestionStyle dangerouslySetInnerHTML={{ __html: question.case_context || '' }} />
      </ContextCard>

      <PanelCard>
        <ClientBubble message={currentStep.statement || ''} />
        <AnswerOptions
          answers={currentStep.answers || []}
          selectedOption={selectedOption}
          onOptionClick={onOptionClick}
          showResults={isReviewMode}
        />
      </PanelCard>
    </SplitLayout>
  );
};
